module.exports = __webpack_public_path__ + "9434db7cf95b5e23879ff61f33427860.pdf";